var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3C2.89543 3 2 3.89543 2 5V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V5C22 3.89543 21.1046 3 20 3H4ZM8.62499 8.6296C8.72188 7.80744 9.57864 7.31143 10.3401 7.63811C10.8441 7.85432 11.9082 8.33973 13.2562 9.11795C14.6049 9.89665 15.5577 10.5759 15.9966 10.904C16.6579 11.3985 16.6608 12.3872 15.9967 12.8836C15.5601 13.21 14.6147 13.883 13.2551 14.6679C11.8961 15.4525 10.8409 15.9347 10.3398 16.1497C9.57694 16.4771 8.72176 15.9789 8.62504 15.1584C8.56076 14.6132 8.44938 13.4451 8.44938 11.8938C8.44938 10.3428 8.5607 9.17504 8.62499 8.6296Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoFill);
export default __webpack_public_path__ + "static/media/video_fill.d3661a86924028b7c6df6e1e6f5c0110.svg";
export { ForwardRef as ReactComponent };